module.exports = __webpack_public_path__ + "img/banner.d6f48116.webp";